import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../../../Components/Header';
import { FooterMenu } from '../../../../Components/FooterMenu';
import { UserList } from '../../../../Components/Admin/Users';

export const AgentClosedUsersList = () => {
  const { t } = useTranslation();

  return (
    <div className='agent_layout'>
      <Header name={t('admin.members.closed')} agentMenu={true} backToHome={true} />
      <UserList isAgent={true} closed={true} />
      <FooterMenu />
    </div>
  );
};
